<template>
  <span v-if="percentage == null">-</span>
  <span v-else class="vcr-pct" :class="`vcr-pct--${tone}`">{{ formatted }}%</span>
</template>

<script>
// Threshold from the CST-4387 design; a thin margin is flagged, not blocked.
const LOW_MARGIN_PERCENTAGE = 10

export default {
  props: {
    percentage: { type: Number, default: null },
  },
  computed: {
    tone() {
      if (this.percentage < 0) return 'negative'
      if (this.percentage < LOW_MARGIN_PERCENTAGE) return 'low'
      return 'healthy'
    },
    formatted() {
      return this.percentage.toLocaleString('nl-NL', { maximumFractionDigits: 2 })
    },
  },
}
</script>
